import { getFieldsV2, basicStrapiRequest } from 'strapi/client';
import { PageWithDescriptionsProps } from 'strapi/page/types';
import { pageTypes } from 'strapi/pageTypes';

import { KeyPointsProps } from '../../shared/KeyPointsColumn/types';
import { isPageWithDescriptions, MICRO_APP_PAGE_TYPES } from '../types';

import { createKeyPoint } from './createKeyPoint';

export const fetchMicroAppPages = async (
  currentPageKey: string
): Promise<KeyPointsProps[]> => {
  const keyPoints: KeyPointsProps[] = [];

  const pagesResponses = await Promise.all(
    MICRO_APP_PAGE_TYPES.filter((pageType) => pageType !== currentPageKey).map(
      (pageType) =>
        getFieldsV2<PageWithDescriptionsProps>({
          pageKey: pageType,
          fields: ['path', 'descriptiveName', 'pageDescription'],
          populate: {
            cover: true,
          },
        })
    )
  );

  const isValidPageArray = (
    pageInfo: PageWithDescriptionsProps | PageWithDescriptionsProps[]
  ): pageInfo is PageWithDescriptionsProps[] => {
    return Array.isArray(pageInfo) && pageInfo.length > 0;
  };

  pagesResponses.forEach((pageResponse) => {
    if (!('error' in pageResponse)) {
      const pageInfo = isValidPageArray(pageResponse)
        ? pageResponse[0]
        : pageResponse;

      if (isPageWithDescriptions(pageInfo)) {
        keyPoints.push(createKeyPoint(pageInfo));
      }
    }
  });

  return keyPoints;
};

export const fetchFeaturePages = async (
  currentPageKey: string,
  currentPagePath: string
): Promise<KeyPointsProps[]> => {
  const excludeCurrentPage = {
    path: {
      $ne: currentPagePath,
    },
  };

  const pagesInfo = await basicStrapiRequest<PageWithDescriptionsProps>({
    pageKey: pageTypes.FEATURES_CHILD_COLLECTION_TYPE,
    requestObject: {
      fields: ['path', 'slug', 'descriptiveName', 'pageDescription'],
      populate: {
        cover: true,
      },
      filters:
        currentPageKey === pageTypes.FEATURES_CHILD_COLLECTION_TYPE
          ? excludeCurrentPage
          : {},
    },
  });

  if (!('error' in pagesInfo)) {
    return pagesInfo.map(createKeyPoint);
  }

  return [];
};
